<template>
    <div style="position:relative">
        <ul class="nav navbar-nav navbar-rightx userNav hidden-sm searchIcon">
            <li>
                <a href="#" @click.prevent="toggleSearchForm('toggle')"><i class="fas fa-search navbar-right"></i></a>
            </li>
        </ul>
        <div id="navSearchForm" v-show="showSearchForm">
            <form :action="searchUrl" id="homeSearch" method="get" @submit="hideSearchForm">
                <div class="input-group">
                    <input 
                        type="text" 
                        class="form-control" 
                        :placeholder="inputPlaceHolder" 
                        id="navSearchFormInput" 
                        name="s" 
                        value="" 
                        tabindex="1" 
                        @blur="hideSearchForm"
                        @keyup.esc="hideSearchForm"
                        @keyup.enter="hideSearchForm"
                    >
                    <span class="input-group-btn">
                        <input type="submit" class="btn btn-success" :value="buttonLabel">
                    </span>
                </div><!-- /input-group -->
            </form>
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';

defineProps({
    searchUrl: String,
    inputPlaceHolder: String,
    buttonLabel: String,
});

const searchIsActive = ref(false);

const showSearchForm = computed(() => {
    return searchIsActive.value;
});

const logSearchUsage = () => {
    window.trackGAEvent('search', 'Button click', 'Open nav quick search');
};

const toggleSearchForm = (toggleValue) => {
    if (toggleValue === 'toggle') {
        searchIsActive.value = !searchIsActive.value;
    } else {
        searchIsActive.value = toggleValue;
    }

    if (searchIsActive.value) {
        setTimeout(() => {
            document.getElementById('navSearchFormInput').focus();
            document.getElementById('navSearchFormInput').select();
        }, 200);

        logSearchUsage();
    }
};

const hideSearchForm = () => {
    setTimeout(() => {
        toggleSearchForm(false);
    }, 200);
};
</script>
    
<style scoped>
/* Scoped Styles */
    /* navbar search form */
    ul.searchIcon a {
        font-size: 20px;
    }

    #navSearchForm {
        position: absolute;
        right: -40px;
        top: 59px;
        width: 400px;
        z-index: 1000;
    }
</style>
